import Button from '@/atoms/Button';
import Input from '@/atoms/forms/Input';
import VisualRadioList from '@/atoms/forms/radio/VisualRadioList';
import Spinner from '@/atoms/loader/Spinner';
import Form from '@/molecules/Form';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import useWalletPlanOptions from './hook';
import { PaymentCardCardPayinJsonldPaymentPaymentCardPayinRead } from '@/api/generated';

export type WalletPlanProps = {
  submitLabel?: string;
  minimumAmount?: number;
  isLoading?: boolean;
  onPayinSuccess?: (payin: PaymentCardCardPayinJsonldPaymentPaymentCardPayinRead) => void;
};

const WalletPlanOptions = ({
  submitLabel = 'validate',
  minimumAmount,
  isLoading: isCheckoutLoading,
  onPayinSuccess,
}: WalletPlanProps) => {
  const {
    formMethods,
    handleSubmit,
    planOptions,
    isLoading: isPlanLoading,
    setValue,
  } = useWalletPlanOptions({ minimumAmount, onPayinSuccess });
  const { t } = useTranslation();
  const isLoading = isCheckoutLoading || isPlanLoading;

  return (
    <FormProvider {...formMethods}>
      <Form isMutating={isLoading} onSubmit={handleSubmit}>
        {isPlanLoading && <Spinner />}
        <div className="flex flex-col gap-4 mt-4">
          {planOptions && (
            <VisualRadioList
              name="planOptions"
              onChange={(value) => {
                setValue('plan', Number(value));
              }}
              options={planOptions}
              supportingText={t('reloadwallet.modal.plan.supportingText')}
              title={t('reloadwallet.modal.plan.label')}
              hideErrorMsg
              isFullWidth
            />
          )}
          <Input
            label={t('reloadwallet.modal.plan.freeAmount')}
            name="plan"
            onChange={({ target: { value } }) => {
              setValue('planOptions', value);
            }}
            type="number"
          />
        </div>
        <Button disabled={isPlanLoading} type="submit">
          {t(submitLabel)}
        </Button>
      </Form>
    </FormProvider>
  );
};
export default WalletPlanOptions;
